const exercisesClassifications = [
  { value: "Fraco", label: "Fraco" },
  { value: "Regular", label: "Regular" },
  { value: "Médio", label: "Médio" },
  { value: "Bom", label: "Bom" },
  { value: "Excelente", label: "Excelente" },
];

export const getExerciseFromValue = (value) => {
  const res = exercisesClassifications.find(
    (exerciseClassification) => value === exerciseClassification.value
  );
  return res;
};

export default exercisesClassifications;
